<template>
<button
  v-if="ticket.stockId"
  title="Imprimir documentação"
  class="btn btn-fill btn-icon btn-info"
  @click="handleDocumentsPrint()"
>
  <i class="ti-files"></i>
</button>
</template>
<script>

export default {
  name: 'btn-open-tickets-documentations-print',

  props: {
    ticket: {
      required: true,
      type: Object
    }
  },

  methods: {
    handleDocumentsPrint () {
      let routeData = this.$router.resolve({
        name: 'documents.print',
        params: { eventId: this.ticket.eventId, ticketId: this.ticket._id }
      })
      window.open(
        routeData.href,
        'documentsWindow',
        'menubar=false,location=false,resizable=false,scrollbars=1,status=false'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/BtnOpenTicketsDocumentationsPrint.vue